import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { IStorefrontSettings } from '../Api/Models/StorefrontSettings';
import { ISessionDetails } from '../Api/Models/SessionDetails';

export interface AuthState {
    token?: string;
    storefrontSettings?: IStorefrontSettings;
    session?: ISessionDetails;
    permissions?: string[];
}

const initialState: AuthState = {
    token: undefined,
    session: undefined,
};

export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setPermissions: (state, action: PayloadAction<string[]>) => {
            state.permissions = action.payload;
        },
        setToken: (state, action: PayloadAction<string>) => {
            state.token = action.payload
        },
        setTokenDetails: (state, action: PayloadAction<{token: string, details: ISessionDetails}>) => {
            state.token = action.payload.token;
            state.session = action.payload.details;
        },
        setSession: (state, action: PayloadAction<ISessionDetails>) => {
            state.session = action.payload;
        },
        clearSession: (state) => {
            state.token = undefined;
            state.session = undefined;
        },
        setStorefront: (state, action: PayloadAction<IStorefrontSettings>) => {
            state.storefrontSettings = action.payload
        },
    },
});

export const {
    setToken,
    setStorefront,
    clearSession,
    setTokenDetails,
    setSession,
    setPermissions
} = authSlice.actions;

export default authSlice.reducer;